import {
  applyingForAnotherOptions,
  employmentStatusZendeskOptions,
  hardshipDurationZendeskOptions,
  primaryReasonZendeskOptions,
  secondaryReasonZendeskOptions,
} from "library/zendeskAPI/customFieldsMap/hardshipApplicationCustomFieldsMap";

export const trueFalseOptions = [
  {
    label: "Yes",
    value: "true",
  },
  {
    label: "No",
    value: "false",
  },
] as const;

export const applyingOnBehalfOfOtherOption = applyingForAnotherOptions.map(
  ({ name: label, value }) => ({ label, value }),
);

// TODO: remove after confirmed with Zendesk
// [
//   { label: "Bereavement / Loss of loved one", value: "bereavement" },
//   { label: "Business Failure", value: "business-failure" },
//   { label: "Carer / Sickness of a loved one", value: "carer" },
//   { label: "Family violence / Financial abuse", value: "abuse" },
//   {
//     label: "Financially overcommitted",
//     value: "financially-over-overcommitted",
//   },
//   { label: "Incarceration", value: "incarceration" },
//   { label: "Maternity", value: "maternity" },
//   { label: "Medical condition", value: "medical" },
//   { label: "Natural disaster", value: "natural-disaster" },
//   { label: "Reduced income", value: "reduced-income" },
//   { label: "Separation / end of a relationship", value: "separation" },
//   { label: "Unemployment", value: "unemployment" },
//   { label: "Other", value: "other" },
// ] as const;

export const primaryReasonOptions = primaryReasonZendeskOptions.map(
  ({ name: label, value }) => ({ label, value }),
);

export const secondaryReasonOptions = secondaryReasonZendeskOptions.map(
  ({ name: label, value }) => ({ label, value }),
);

export const employmentStatusOptions = employmentStatusZendeskOptions.map(
  ({ name: label, value }) => ({ label, value }),
);

export const durationOfHardshipOptions = hardshipDurationZendeskOptions.map(
  ({ name: label, value }) => ({ label, value }),
);
